import { CanActivateFn } from '@angular/router';
import { environment } from '@env';
import { of } from 'rxjs';

export const testEnvOnlyGuard: CanActivateFn = () => of(!environment.production);
